import '~console';
import {
  StrictMode,
} from 'react';
import {
  createRoot,
} from 'react-dom/client';

import {
  EntryComponent,
} from '#src/entry';
import {
  createRouter,
} from '#src/router';

// Create a router instance
const router = createRouter();
// Render the app
const rootElement = document.getElementById('app');
if (!rootElement) {
  throw new Error('Cannot get \'#app\' selector from document');
}

if (!rootElement.innerHTML) {
  const root = createRoot(rootElement);
  root.render(
    <StrictMode>
      <EntryComponent
        router={ router }
      />
    </StrictMode>,
  );
}
